import React from 'react';
import './BusinessShowcase.css';

const BUSINESS_CATS = [
  {
    id: 'product',
    label: 'Product',
    image: '/images/Website first page Business/_NIK2900.jpg',
  },
  {
    id: 'industrial',
    label: 'Industrial',
    image: '/images/Website first page Business/DSC_0001.jpg',
  },
  {
    id: 'interior',
    label: 'Interior',
    image: '/images/Website first page Business/DSC03641_Interior.jpg',
  },
  {
    id: 'exterior',
    label: 'Exterior',
    image: '/images/Website first page Business/exterior_building.jpg',
  },
  {
    id: 'corporate',
    label: 'Corporate',
    image: '/images/Website first page Business/_NIK6661_Corporate.jpg',
  },
  {
    id: 'sport',
    label: 'Sports',
    image: '/images/Website first page Business/IMG_9500_Sports.JPG',
  },
  {
    id: 'wildlife',
    label: 'Wildlife',
    image: '/images/Website first page Business/NIK_9518_Wildlife.jpg',
  },
];

const BusinessShowcase = ({ onCategoryClick }) => {
  const go = (cat) => onCategoryClick && onCategoryClick(cat);

  const rows = [
    BUSINESS_CATS.slice(0, 2),
    BUSINESS_CATS.slice(2, 4),
    BUSINESS_CATS.slice(4, 6),
    BUSINESS_CATS.slice(6, 8),
  ];

  return (
    <section className="bs-section bs-section--business">
      <div className="bs-header">
        <span className="bs-eyebrow">Professional Visuals</span>
        <h2 className="bs-title">Business Photography</h2>
        <p className="bs-subtitle">Premium photography solutions for your brand and business needs</p>
      </div>

      <div className="bs-canvas">
        {rows.map((row, ri) => (
          <div key={ri} className="bs-row">
            {row.map((cat, ci) => (
              <div
                key={cat.id}
                className="bs-pair reveal-scale"
                onClick={() => go(cat)}
                style={{ animationDelay: `${(ri * 2 + ci) * 0.1}s` }}
              >
                <div className="bs-label">
                  <span>{cat.label}</span>
                </div>

                <div className="bs-photo">
                  <img src={cat.image} alt={cat.label} />
                  <div className="bs-photo-overlay">
                    <span className="view-text">View Gallery</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default BusinessShowcase;
